import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { ZoneTable } from '@/components/Pages/Zones/ZoneTable';
import { CreateEditZoneModal } from '@/components/Pages/Zones/CreateEditZoneModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/zones')({
  component: ZonesPage,
  head: () => pageTitle('Zonas'),
});

function ZonesPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('WAREHOUSE_READ');
  const canWrite = hasClaim('WAREHOUSE_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditZoneModal />
        </Box>
      )}
      <ZoneTable />
    </Box>
  );
}
